import {
  buildUpdateLog,
  updateLogUsecase as _updateLogUsecase,
} from "./update-log";
import { buildGetLogs, getLogsUsecase as _getLogsUsecase } from "./get-logs";

import LogRepository from "../../ports/logRepository";

// eslint-disable-next-line import/no-anonymous-default-export
export default (dependencies: {
  logRepo: LogRepository;
}): {
  updateLog: _updateLogUsecase;
  getLogs: _getLogsUsecase;
} => {
  const { logRepo } = dependencies;

  const updateLog = buildUpdateLog({ logRepo });
  const getLogs = buildGetLogs({ logRepo });

  return { updateLog, getLogs };
};

export type updateLogUsecase = _updateLogUsecase;
export type getLogsUsecase = _getLogsUsecase;
